<!DOCTYPE html>
<html lang="en">
  <head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>Login Page</title>
    <link rel="stylesheet" href="account-setup-success.component.scss" />
  </head>
  <body>
    <div class="container">

      <main>
        <!-- Off-screen heading for accessibility -->
        <h1 class="sr-only">Account Setup Success Page</h1>

        <div class="login-box">
          <div class="logo-container">
            <img
              src="assets/images/e-logo.png"
              alt="eligibility logo"
              style="max-height: 100%; max-width: 150px;"
            />
          </div>
          <div class="login-instructions">
            <h2>Welcome!</h2>
            <p class="instruction">
              {{ errorMessage ? errorMessage : 'You have successfully setup your account.' }}
            </p>
          </div>
          <p class="login-method" *ngIf="!errorMessage">Please sign in with your credentials.
          </p>
          <button class="signin-button button-default custom-btn-primary" (click)="signInWithAzureAD()" *ngIf="!errorMessage">
            Sign in
          </button>
        </div>
      </main>
    </div>
  </body>
</html>
